import React from "react";
import { Outlet } from "react-router";

function PapersOutlet() {
  return <Outlet />;
}

export default PapersOutlet;
